import React from 'react';
import '@inovua/reactdatagrid-community/index.css';
export function BotsActions() {
    return (<div>Действия над ботами</div>);
}
